import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryProposalIncentivesDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useBatteryProposalIncentives(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<BatteryProposalIncentivesDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.incentives(proposalId ?? ``),
    queryFn: () => {
      if (!proposalId) {
        throw new Error(`Battery-Only Proposal id is required`)
      }

      return batteryProposalService.getIncentives(proposalId)
    },
    enabled: Boolean(proposalId) && enabled,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
